<template>
  <div class="ncl">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      :disabled="ableFlag"
      ref="pullRefresh"
      :class="{activeMore: isMore}"
    >
      <div class="c-wrapper" v-if="getData.length > 0">
        <div  class="circleHeight">
          <div class="slide" ref="slide" :class="{portrait: isMore}">
            <div class="to-top"></div>
            <div v-for="(items, indexs) of getData[0].indexs" :key="indexs">
              <quota-card
                :quotaCard="items"
                @getFlag1="getFlag1"
                @getCardIndex="getCardIndex"
              ></quota-card>
            </div>
          </div>
        </div>
      </div>
      <div  id="toBottom"></div>
    </van-pull-refresh>
    <home-commonbg class="showImg" v-if="loadFlag"></home-commonbg>
  </div>
</template>

<script>
import QuotaCard from './components/OperateCard'
import HomeCommonbg from '../common/commonBg'
import { postAction } from '@/utils/api'
export default {
  name: 'OperateCard',
  components: {
    QuotaCard,
    HomeCommonbg
  },
  props: {
    swiperListResult: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isLoading: false,
      quotaCard: null,
      ableFlag: false,
      getData: [],
      isMore: false,
      moreText: '更多',
      more: true,
      loadFlag: false,
      indexIdArr: [],
      flag0: false, // 初始化状态 效率类 更多按钮不显示
      flag1: false // 初始化状态 服务类 更多按钮不显示
    }
  },
  methods: {
    // 控制下拉刷新
    getFlag (data) {
      this.ableFlag = data
    },
    getFlag1 (data) {
      this.ableFlag = data
    },
    onRefresh () {
      setTimeout(() => {
        this.$toast('刷新成功')
        this.isLoading = false
      }, 500)
    },
    getCardIndex (indexId) {
      this.indexIdArr.push(indexId)
      // loading控制
      if (this.getData[0].indexs.length === this.indexIdArr.length) {
        this.loadFlag = false
      }
    },
    getHomeInfo () {
      var url = '/performance/menu/menuApi'
      let postData = {
        moduleCode: this.$store.state.user.pageCode,
        userAccount: this.$store.state.user.account
      }
      this.getData = []
      this.indexIdArr = []
      this.loadFlag = true
      var obj = postAction(url, postData)
      obj.then(async (res) => {
        this.getData = await res.data.menuInfo
        if (this.getData[0].indexs.length > 3) {
          this.flag0 = true
        } else if (this.getData[1].indexs.length > 3) {
          this.flag1 = true
        } else {
          this.flag0 = false
          this.flag1 = false
        }
      })
    }
  },
  created () {
  },
  mounted () {
    this.getHomeInfo()
  },
  beforeDestroy () {
    // 当销毁此组件钱将vuex中子组件的channel值置为空字符串
    this.$store.commit('OPE_SET_DETAIL_CHANNEL', '')
  },
  computed: {
    pageCode () {
      return this.$store.state.user.pageCode
    }
  },
  watch: {
    pageCode: {
      handler: function (val, oldVal) {
        this.getHomeInfo()
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus" scoped>
  .ncl {
    padding-top: 0.7rem;
  }
  >>>.van-pull-refresh {
    height: 100%;
  }
.circle
  min-height 0.8rem
  p
    color #333
    font-size 0.12rem
    line-height 2
    span
      display inline-block
      margin 0px 5px
      font-size 0.18rem
      font-family 'numberfont'
  div p
    color #333
    font-size 0.12rem
    line-height 2
    span
      display inline-block
      margin 0px 5px
      font-size 0.18rem
      font-family 'numberfont'
.card-nav {
  border-bottom: 1px solid #F0F0F0;
}
.circle label
  font-weight normal
  font-size 0.14rem
.circleHeight
  background #fff
  position relative
.circleTitle
  font-size 0.18rem
  font-weight 600
  height 0.45rem
  line-height 0.45rem
.circleTitle div:last-child
  text-align right
  padding-left 0.04rem
.circleFooter
  font-size 0.12rem
  color #BDBDBD
.circleHeight>>>.van-circle svg
  transform rotate(-90deg)
.circleHeight>>>.van-circle__text
  font-size 0.15rem
  font-weight 600
.van-col.van-col--8
  text-align center
.van-circle-title
  font-size 0.14rem
  display inherit
  margin-top 18px
.headerKind
  padding-left 0.1rem
  display block
  width 100%
  background #fff
  font-size 0.18rem
  line-height 0.4rem
  color #3399FF;
  font-weight 600;
.contentHeader
  background #ffffff
.moreBtn{
  background #fff
  color #39f
  width 100%
  text-align center
  font-size 14px
  line-height 35px
  border-top 1px solid #f0f0f0
}
.slide > div:last-child  .card-wrapper{
  margin-bottom 0
}
.moreBtn {
  margin-bottom 20px
}
.circleHeight:nth-of-type(1) .slide {
  // height 450px
  overflow hidden
}
.circleHeight:nth-of-type(1) .portrait {
  height unset
}
.showImg{
  position flex
  z-index 1000
}
</style>



// WEBPACK FOOTER //
// src/pages/operate/Operate.vue